const __DateOptions = {
  startDate: null,
  endDate: null
};
export const models = {
  dateRange: { ...__DateOptions },
  type: null,
  payment_type: null,
  status: null,
  for_user: null,
  by_user: null,
  from: null,
  to: null
};
export const options = {
  typeOptions: [],
  statusOptions: []
};

export const Fields = [
  {
    type: "select",
    name: "type",
    label: "type",
    value: "",
    rules: "required",
    options: [],
    validationMessage: {
      required: "Select type please"
    }
  },
  {
    type: "select",
    name: "status",
    label: "status",
    value: "",
    rules: "required",
    options: [],
    validationMessage: {
      required: "Select status please"
    }
  },
  {
    label: "Date range",
    name: "dateRange",
    placeholder: "Select the start date",
    type: "date-range",
    value: "",
    format: "dd-mm-yyyy HH:mm:ss",
    rules: "required",
    validationMessage: {
      required: "This field is required"
    }
  }
];
